<div class="modal-content">
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
  <div class="modal-header">

  <h3 class="modal-title font">Alta nuevo poseedor</h3>

    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <form class="form-search py-3" [formGroup]="formGroup">

      <div class="row-fields">
        <div class="field field-70">
          <label for="razonSocial">Razón Social <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput id="razonSocial" formControlName="razonSocial" placeholder="Razón social">
              <mat-error *ngIf="controlHasError('razonSocial', 'required')">Campo obligatorio</mat-error>
            </mat-form-field>
          </div>
        </div>
          <div class="field field-30">
          <label for="nima">NIMA<span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input type="text" matInput id="nima" formControlName="nima" placeholder="NIMA" maxlength="10">
              <mat-error *ngIf="controlHasError('nima', 'pattern')">Formato incorrecto</mat-error>
              <mat-error *ngIf="controlHasError('nima', 'maxlength')">Máximo 10 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row-fields">
        <div class="field field-40">
          <label for="tipoDocumento">Tipo documento <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="tipoDocumento" (selectionChange)="tipoDocumentoSel($event.value)" id="tipoDocumento" placeholder="-- Tipo documento --">
                <mat-option value="NIF">NIF</mat-option>
                <mat-option value="DNI">DNI</mat-option>
                <mat-option value="NIE">NIE</mat-option>
              </mat-select>
              <mat-error *ngIf="controlHasError('tipoDocumento', 'required')">Campo obligatorio</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="field field-60">
          <label for="codigoDocumento">Documento <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput id="codigoDocumento" formControlName="codigoDocumento" placeholder="Documento" maxlength="10" oninput="this.value = this.value.toUpperCase()">
              <mat-error *ngIf="controlHasError('codigoDocumento', 'required')">Campo obligatorio</mat-error>
              <mat-error *ngIf="controlHasError('codigoDocumento', 'pattern')">Formato incorrecto</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row-fields">
        <div class="field field-100">
          <label for="denominacionCentro">Denominación de centro <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput id="denominacionCentro" formControlName="denominacionCentro" placeholder="Denominación de centro">
              <mat-error *ngIf="controlHasError('denominacionCentro', 'required')">Campo obligatorio</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row-fields">
        <div class="field field-100">
          <label for="cnae">CNAE principal <span class="oblig">*</span></label>
          <div class="custom-mat-field-select">
            <lib-ge-select-pagination [endPointFilter]="cnaeEndpoint" [descripcion]="getCnaeDescription"
              [objQueryName]="getCnaeObjectQuery" [formControlNameSelect]="getFormControl('cnae')"
              [placeHolder]="'--CNAE Principal--'" [customClass]="rightHolder('cnae')">
            </lib-ge-select-pagination>
            <div *ngIf="controlHasErrorSelect('cnae')" class="mat-error">
              Campo obligatorio
            </div>
          </div>
        </div>
      </div>

      <div class="row-fields">
        <div class="field field-50">
          <label for="nombre">Nombre <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput id="nombre" formControlName="nombre" placeholder="Nombre" maxlength="50">
              <mat-error *ngIf="controlHasError('nombre', 'required')">Campo obligatorio</mat-error>
              <mat-error *ngIf="controlHasError('nombre', 'maxlength')">Máximo 50 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="field field-50">
          <label for="apellido1">Apellidos <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput id="apellido1" formControlName="apellido1" placeholder="Apellidos" maxlength="50">
              <mat-error *ngIf="controlHasError('apellido1', 'required')">Campo obligatorio</mat-error>
              <mat-error *ngIf="controlHasError('apellido1', 'maxlength')">Máximo 50 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row-fields">
        <div class="field field-33">
          <label for="pais">País <span class="oblig">*</span></label>
          <div class="custom-mat-field-select">
            <lib-ge-select-pagination (selectedModel)="selectedModel('pais')" [endPointFilter]="paisesEndpoint"
              (filteredList)="filterList($event,'pais')"
              [formControlNameSelect]="getFormControl('pais')" [placeHolder]="'País'" [objQueryName]="'nombre'"
              descripcion="nombre" [customClass]="rightHolder('pais')" [defaultValue]=69>
            </lib-ge-select-pagination>
            <div *ngIf="controlHasErrorSelect('pais')" class="mat-error">
              Campo obligatorio
            </div>
          </div>
        </div>
        <div class="field field-33">
          <label *ngIf="esES()" for="codigoPostal">CP <span class="oblig">*</span></label>
          <label *ngIf="!esES()" for="codigoPostal">CP</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput id="codigoPostal" formControlName="codigoPostal" placeholder="CP" maxlength="255">
              <mat-error *ngIf="controlHasError('codigoPostal', 'required')">Campo obligatorio</mat-error>
              <mat-error *ngIf="controlHasError('codigoPostal', 'pattern')">Formato incorrecto</mat-error>
              <mat-error *ngIf="controlHasError('codigoPostal', 'maxlength')">Máximo 255 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="field field-33" *ngIf="esShow">
          <label for="provincia">Provincia <span class="oblig">*</span></label>
          <div class="custom-mat-field-select">
            <lib-ge-select-pagination (selectedModel)="selectedModel('provincia')" [endPointFilter]="provinciasEndpoint"
              (filteredList)="filterList($event,'provincia')" [formControlNameSelect]="getFormControl('provincia')"
              [placeHolder]="'Provincia'" [objQueryName]="'nombre'" descripcion="nombre"
              [customClass]="rightHolder('provincia')">
            </lib-ge-select-pagination>
            <div *ngIf="controlHasErrorSelect('provincia')" class="mat-error">
              Campo obligatorio
            </div>
          </div>
        </div>
        <div class="field field-33" *ngIf="!esShow">
          <label for="provincia">Provincia</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput id="provincia" formControlName="provincia" placeholder="Provincia" maxlength="255">
              <mat-error *ngIf="controlHasError('provincia', 'maxlength')">Máximo 255 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row-fields">
        <div class="field field-33">
          <label *ngIf="esES()" for="municipio">Municipio <span class="oblig">*</span></label>
          <label *ngIf="!esES()" for="municipio">Municipio</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput id="municipio" formControlName="municipio" placeholder="Municipio" maxlength="255">
              <mat-error *ngIf="controlHasError('municipio', 'required')">Campo obligatorio</mat-error>
              <mat-error *ngIf="controlHasError('municipio', 'maxlength')">Máximo 255 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="field field-45">
          <label *ngIf="esES()" for="nombreVia">Tipo y Nombre de vía <span class="oblig">*</span></label>
          <label *ngIf="!esES()" for="nombreVia">Tipo y Nombre de vía</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput id="nombreVia" formControlName="nombreVia" placeholder="Tipo y Nombre de vía" maxlength="100">
              <mat-error *ngIf="controlHasError('nombreVia', 'required')">Campo obligatorio</mat-error>
              <mat-error *ngIf="controlHasError('nombreVia', 'maxlength')">Máximo 100 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="field field-20">
          <label *ngIf="esES()" for="numero">Número <span class="oblig">*</span></label>
          <label *ngIf="!esES()" for="numero">Número</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput id="numero" formControlName="numero" placeholder="Número" maxlength="5">
              <mat-error *ngIf="controlHasError('numero', 'required')">Campo obligatorio</mat-error>
              <mat-error *ngIf="controlHasError('numero', 'maxlength')">Máximo 5 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>

  </div>
  <div class="modal-footer actions">
    <div class="note"><span>* Campos Obligatorios</span></div>
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" data-dismiss="modal" (click)="cerrar()"
        aria-label="Cancelar">Cancelar</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="guardar()"
        aria-label="Guardar">Guardar</button>
    </div>
  </div>
</div>
